/**
 * @generated SignedSource<<0d60b5c8c25cbd454486a13fd89c929f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "request"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "request",
        "variableName": "request"
      }
    ],
    "concreteType": "UaPaySignResponse",
    "kind": "LinkedField",
    "name": "uaPaySign",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "location",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ImpulseUaPaySignPaymentCheckoutPagesMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ImpulseUaPaySignPaymentCheckoutPagesMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ac6679fec4d669f2fe393973f3bd6f68",
    "id": null,
    "metadata": {},
    "name": "ImpulseUaPaySignPaymentCheckoutPagesMutation",
    "operationKind": "mutation",
    "text": "mutation ImpulseUaPaySignPaymentCheckoutPagesMutation(\n  $request: UaPaySignRequestInput\n) {\n  uaPaySign(request: $request) {\n    location\n  }\n}\n"
  }
};
})();

node.hash = "dc55f336d0c1bb662985932e89f0d8c7";

module.exports = node;
